import { render, staticRenderFns } from "./OdpDeleteCreditModal.vue?vue&type=template&id=074da4f4"
import script from "./OdpDeleteCreditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OdpDeleteCreditModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports